import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import SectionRenderer from "@/components/site/SectionRenderer";
import SEO from "@/components/site/SEO";
import NotFound from "@/pages/NotFound";
import { useLanguage } from "@/i18n/LanguageContext";
import { bi } from "@/lib/bilingual";
import { useCachedGet } from "@/hooks/useCachedGet";
import PageSkeleton from "@/components/site/PageSkeleton";

const PageRenderer = () => {
  const { slug } = useParams();
  const { t, lang } = useLanguage();
  const { data: page, ready } = useCachedGet(`/pages/public/${slug}`);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  if (!ready) return <PageSkeleton />;
  if (page === false || !page) return <NotFound />;

  return (
    <div>
      <SEO
        title={bi(page.seo_title, lang) || page.title}
        description={bi(page.seo_description, lang)}
        breadcrumbs={[
          { name: t("nav.home"), url: window.location.origin + "/" },
          { name: page.title, url: window.location.href },
        ]}
      />
      <div className="pt-6" />
      {(page.sections || []).map((s) => (
        <SectionRenderer key={s.id} section={s} />
      ))}
    </div>
  );
};

export default PageRenderer;
